module.exports = __webpack_public_path__ + "img/resources-1440.5649b5e5.jpg";